"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISpiceNetworkAnalysisResultSerializedSchema = void 0;
const zod_1 = require("zod");
const AnalysisRequirements_1 = require("../../AnalysisRequirements");
const NetStatsWithDependenciesSerialized_1 = require("../../CircuitStates/NetStatsWithDependenciesSerialized");
const ProjectModelNetStats_1 = require("../../DesignModels/ProjectModelNetStats");
const ISerializedCircuitState_1 = require("../../CircuitStates/ISerializedCircuitState");
const ISimulationManifestEntry_1 = require("../../SPICE/ISimulationManifestEntry");
exports.ISpiceNetworkAnalysisResultSerializedSchema = zod_1.default.object({
    type: zod_1.default.literal(AnalysisRequirements_1.AnalysisType.SpiceNetworkAnalysis),
    result: zod_1.default.object({
        netStatsByModes: zod_1.default.lazy(() => NetStatsWithDependenciesSerialized_1.NetStatsWithDependenciesSerializedSchema).array(),
        overallNetStats: ProjectModelNetStats_1.ProjectModelNetStatsSchema,
        simulations: ISimulationManifestEntry_1.ISimulationManifestEntrySerializedSchema.array(),
        simulationArtifacts: ISimulationManifestEntry_1.ISpiceSimulationArtifactSchema.array(),
        circuitStates: ISerializedCircuitState_1.SerializedCircuitStateMapSchema,
    }),
});
//# sourceMappingURL=ISpiceNetworkAnalysisResultSerialized.js.map